import React, { createElement, useEffect, Children, useState } from 'react';
import classNames from 'classnames';
import TabPane from './colorful-tabPane';
import './index.scss';
const ColorfulTabs = function ColorfulTabs({ defaultIndex = 0, type = 'underline', className, onClick, tabPanes, children, }) {
    const prefixCls = 'au-tabs';
    const tabsClassName = classNames(prefixCls, {
        [`${prefixCls}-${type}`]: !!type,
    }, className);
    const [activeIndex, setActiveIndex] = useState(defaultIndex);
    let childrenToRender = children;
    let content = '';
    useEffect(() => {
        setActiveIndex(defaultIndex);
    }, [defaultIndex]);
    const onChangeItem = itemIndex => {
        if (itemIndex !== activeIndex)
            setActiveIndex(itemIndex);
        if (onClick) {
            onClick(itemIndex);
        }
        ;
    };
    if (tabPanes && tabPanes.length > 0) {
        childrenToRender = tabPanes.map((option, i) => {
            return (createElement(TabPane, { ...option, index: i, key: option?.title || '' }, option?.children || ''));
        });
    }
    const tagNode = (createElement("div", { className: tabsClassName },
        createElement("ul", { className: "au-tab-pane-head" }, Children.map(childrenToRender, (child, index) => {
            if (activeIndex === child.props?.index) {
                content = child.props?.content || child.props?.children;
            }
            return React.cloneElement(child, {
                index,
                title: child.props?.title,
                isCollapsed: activeIndex === child.props?.index,
                onClick: () => { onChangeItem(child.props?.index); },
            });
        })),
        createElement("div", { className: "au-tab-pane-content" }, content)));
    return tagNode;
};
ColorfulTabs.TabPane = TabPane;
ColorfulTabs.displayName = 'ColorfulTabs';
export default ColorfulTabs;
